import { GarmentTag } from '../ui/GarmentTag';
import { WHATSAPP_NUMBER } from '../../constants/contact';

function WhatsAppIcon() {
  return (
    <svg className="w-4 h-4 text-olivine-dark shrink-0" fill="currentColor" viewBox="0 0 24 24">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.533 5.85L.057 23.535a.75.75 0 0 0 .916.928l5.803-1.524A11.938 11.938 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.853 0-3.587-.5-5.084-1.375l-.361-.214-3.742.981.998-3.648-.235-.374A9.963 9.963 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg className="w-4 h-4 text-olivine-dark shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}

const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

interface TrustItem {
  icon: React.ReactNode;
  label: string;
  to?: string;
  href?: string;
}

const TRUST_ITEMS: TrustItem[] = [
  {
    icon: <WhatsAppIcon />,
    label: 'Frete e entrega combinados no WhatsApp',
    href: WHATSAPP_URL,
  },
  {
    icon: <ClockIcon />,
    label: 'Atendimento na loja física de Segunda a Sábado',
    to: '/sobre',
  },
];

export function TrustStrip() {
  return (
    <div className="max-w-[1600px] mx-auto px-4 pt-10 flex flex-wrap justify-center gap-3">
      {TRUST_ITEMS.map((item, idx) => (
        <GarmentTag
          key={item.label}
          to={item.to}
          href={item.href}
          target={item.href ? '_blank' : undefined}
          rel={item.href ? 'noopener noreferrer' : undefined}
          className={`max-sm:whitespace-normal max-sm:text-left ${idx % 2 === 0 ? 'sm:-rotate-1' : 'sm:rotate-1'}`}
        >
          {item.icon}
          <span className="text-text-medium">{item.label}</span>
        </GarmentTag>
      ))}
    </div>
  );
}
